const accessCropManagement = {

    CROP_STAGE_MASTER_LIST: {
        path: '/crop-stage-master-list'
    },

    ADD_CROP_STAGE_MASTER: {
        path: '/create-crop-stage-master'
    },

    UPDATE_CROP_STAGE_MASTER: {
        path: '/edit-crop-stage-master'
    },

    DELETE_CROP_STAGE_MASTER: {
        path: '/delete-crop-stage-master'
    },

    CROP_SCHEDULE_VARIANT_LIST: {
        path: '/crop-schedule-variant-list'
    },

    ADD_CROP_SCHEDULE_VARIANT: {
        path: '/create-crop-schedule-variant'
    },

    UPDATE_CROP_SCHEDULE_VARIANT: {
        path: '/edit-crop-schedule-variant'
    },

    DELETE_CROP_SCHEDULE_VARIANT: {
        path: '/delete-crop-schedule-variant'
    },

    DAY_WISE_SCHEDULE_LIST: {
        path: '/daywise-schedule-list'
    },

    ADD_DAY_WISE_SCHEDULE: {
        path: '/create-daywise-schedule'
    },

    UPDATE_DAY_WISE_SCHEDULE: {
        path: '/edit-daywise-schedule'
    },

    DELETE_DAY_WISE_SCHEDULE: {
        path: '/delete-daywise-schedule'
    },

    DAY_WISE_SCHEDULE_DETAILS: {
        path: '/daywise-schedule-details'
    },

}

export default accessCropManagement;
